import Styles from './MoreButton.module.scss'
import cx from 'classnames'

interface Props {
  isTruncated: boolean
  setIsTruncated: React.Dispatch<React.SetStateAction<boolean>>
}

export const MoreButton = ({ isTruncated, setIsTruncated }: Props) => {
  return (
    <button
      className={cx(Styles.moreButton, { [Styles.expanded]: !isTruncated })}
      onClick={() => setIsTruncated(!isTruncated)}
    >
      {isTruncated ? 'see more' : 'See less'}
    </button>
  )
}
